/** Generate a unique ID with prefix for cross-referencing between widgets */
export const generateId = (prefix: string = 'item'): string =>
  `${prefix}_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;

/** Parse a comma-separated tag string into a cleaned array */
export const parseTags = (tagString: string): string[] =>
  tagString.split(',').map(t => t.trim()).filter(Boolean);
